<template>
  <div id="error">
    <div class="container">
      <div class="d-flex flex-column align-items-start justify-content-center w-100 h-100">
        <h1>404</h1>
        <p>您所瀏覽的頁面不存在，點此回首頁</p>
        <router-link to="/" class="btn btn-sm btn-primary-light mt-20">回首頁</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error',
  metaInfo: {
    title: '頁面錯誤 | ',
  },
  mounted() {
    this.$router.push({ name: 'Home' });
  },
};
</script>
<style lang="scss" scoped>
#error {
  min-height: calc(100vh - 70px - 300px - 80px);
  padding: 80px 0;
}
</style>
